import React from 'react';
import { motion } from 'framer-motion';
import { useSessionStore } from '../../store/sessionStore';
import { SIGN_DISPLAY_TEXT } from '../../constants/signDisplayText';

export const SignHistoryChips: React.FC = () => {
  const { signHistory } = useSessionStore();

  if (signHistory.length === 0) return null;

  return (
    <div
      className="rounded-2xl p-3 flex-shrink-0"
      style={{
        background: 'rgba(13,23,48,0.5)',
        border: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      <span className="text-[10px] font-bold tracking-widest text-slate-600 uppercase block mb-2">
        Histórico
      </span>
      <div className="flex flex-wrap gap-1.5">
        {signHistory.map((sign, index) => {
          const pct = Math.round(sign.confidence * 100);
          return (
            <motion.div
              key={`${sign.label}-${sign.timestamp}`}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.03 }}
              className="flex items-center gap-1.5 px-2.5 py-1 rounded-xl"
              style={{
                background: 'rgba(14,165,233,0.08)',
                border: '1px solid rgba(14,165,233,0.15)',
              }}
            >
              <span className="text-slate-300 text-xs font-medium leading-none">
                {SIGN_DISPLAY_TEXT[sign.label] ?? sign.label}
              </span>
              <span
                className="text-[10px] font-bold leading-none"
                style={{ color: pct >= 85 ? '#2dd4bf' : '#38bdf8' }}
              >
                {pct}%
              </span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
